var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"comment-list"},[_vm._l((_vm.comments),function(comment){return _c('comment-item',{key:comment.id,attrs:{"comment":comment}})}),_c('li',{staticClass:"mt-4 comment-create-item"},[_c('comment-create')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }